<template>
    <template v-if="this.$route.meta.withoutLayout">
      <router-view></router-view>
    </template>
  <template v-else>
  <div class="content-area">
    <div class="aside">
      <Sidebar/>
    </div>
    <div class="content">
      <div class="content-data">
      <router-view></router-view>
      </div>
      <div></div>
      <Footer/>
    </div>
  </div>
  
 
</template>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Sidebar,
    Footer
  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
